import { get, post } from '@/api/request'
import { utilities } from '@billow/js-helpers'

export default {

  loadActiveCompany: (success, failure) => {
    return get(
      '/api/company',
      response => success(response),
      error => failure(error)
    )
  },
  save: (payload, success, failure) => {
    return post(
      '/api/company',
      payload,
      response => success(response),
      error => failure(error)
    )
  },
  uploadLogo: (file, success, failure) => {
    return post(
      `/api/company/logo`,
      utilities.formData({file}),
      response => success(response),
      error => failure(error)
    )
  },
  toggleSearchable: (success, failure) => {
    return post(
      `/api/company/toggle-searchable`,
      {},
      response => success(response),
      error => failure(error)
    )
  },
  loadNotificationChannels: (success, failure) => {
    return get(
      `/api/company/notification-channels`,
      response => success(response),
      error => failure(error)
    )
  }
}